var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShelter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5.988,
    cy: 8.993,
    r: 0.772,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.871,10.373a.345.345,0,0,0,.345.344H7.142c.009,0,.016.011.026.011h4.116a.2.2,0,0,0,.2-.2v-.357a1.253,1.253,0,0,0-1.253-1.253h-2.6a.67.67,0,0,0-.669.669v.443H5.216A.345.345,0,0,0,4.871,10.373Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.509,11.093H3.748V7.743l8.92-3.287a.458.458,0,0,0-.318-.86L2.193,7.339a.459.459,0,0,0,.159.889A.437.437,0,0,0,2.51,8.2l.32-.117v3.011H2.352a.459.459,0,0,0,0,.918H12.509a.459.459,0,0,0,0-.918Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelter);
export default __webpack_public_path__ + "static/media/SHELTER.bf7906a5683f971d6f7a02da8a34b69e.svg";
export { ForwardRef as ReactComponent };